import { On3IconLockPremium } from '@on3/icons/index';
import { useAuth } from '@on3/ui-lib/index';

export const PremiumArticleLock = ({ className }: { className?: string }) => {
  const { user } = useAuth();

  if (!user?.has) return null;

  return <On3IconLockPremium className={className} />;
};
